<template>
  <div>
    <b-modal
      id="LiveAnalytic"
      title="จุดติดตั้งทั้งหมด (สายทาง)"
      size="xl"
      ok-only
      ok-title="ปิด"
    >
      <div>
        <b-row>
          <b-col
            v-for="(link, index) in rtsp"
            :key="index"
            lg="4"
            md="6"
            sm="12"
            xl="3"
          >
            <br>
            <b-card
              no-body
            >
              <b-link
                v-b-modal="'LiveAnalyticCCTV'"
                @click="$refs.RTSP.streamLive(rtsp[index])"
              >
                <VideoPlayer :source="rtsp[index]" />
              </b-link>
              <b-card-text
                style="  z-index: 2;"
              >
                <b-row>
                  <b-col cols="2">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="overflow: auto;"
                    >
                      <rect
                        width="48"
                        height="48"
                        rx="4"
                        fill="url(#paint0_linear_431_10636)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_431_10636"
                          x1="24"
                          y1="0"
                          x2="24"
                          y2="48"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#99e2fb" />
                          <stop
                            offset="0.404167"
                            stop-color="#00a2ff"
                          />
                        </linearGradient>
                      </defs>
                      <foreignObject
                        width="100%"
                        height="100%"
                        y="9"
                        style="text-align:center"
                      >
                        <h1> {{ index+1 }} </h1>
                      </foreignObject>
                    </svg>
                  </b-col>
                  <b-col cols="10">
                    <div
                      style=" margin: 0; position: absolute; top: 50%; transform:translate(-3%, -50%);"
                    >{{ name[index] }}</div>
                  </b-col>
                </b-row>

              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <Live
          ref="RTSP"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BModal, BCard, BCardText, BLink,
} from 'bootstrap-vue'
import axios from '@axios'
import Live from './LiveRTSP.vue'
import VideoPlayer from './VideoPlayer.vue'

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BCard,
    BCardText,
    BLink,
    Live,
    VideoPlayer,
  },
  data() {
    return {
      rtsp: [],
      name: [],
      rtspData: [],
      ISOnline: [],
      cctvError: '',
      poster: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
  },
  mounted() {
    this.getRTSPCCTV()
    // await this.for()
    this.interval = setInterval(async () => {
      await this.getRTSPCCTV()
    }, 600000)
  },
  methods: {
    getRTSPCCTV() {
      // 741
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCamAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.rtspData.splice(0)
            this.rtsp.splice(0)
            this.name.splice(0)
            this.rtspData = response.data
            this.rtspData.forEach(value => {
              this.rtsp.push(value.RTSP_URL)
              this.name.push(value.Camera_Desc)
              this.ISOnline.push(value.ISOnline)
            })
          // this.for()
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCamAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.rtspData.splice(0)
            this.rtsp.splice(0)
            this.name.splice(0)
            this.rtspData = response.data
            this.rtspData.forEach(value => {
              this.rtsp.push(value.RTSP_URL)
              this.name.push(value.Camera_Desc)
              this.ISOnline.push(value.ISOnline)
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    for() {
      setTimeout(() => this.rtsp.forEach((value, i) => {
        this.stream(value, i)
      }), 1000)
    },
    async stream(value, i) {
      if (this.ISOnline[i] === 'Online') {
        await axios
          .get(value)
        // eslint-disable-next-line no-unused-vars
          .then(response => {
            const video = document.querySelector(`#video${i}`)
            // const videoSrc = value
            if (value) {
              // this.hls = new Hls(this.config)
              // // eslint-disable-next-line global-require
              // video.poster = require('@/assets/images/icons/no-signal.gif')
              // if (video.canPlayType('application/vnd.apple.mpegurl')) {
              //   video.src = videoSrc
              // } else if (Hls.isSupported()) {
              //   this.hls.loadSource(videoSrc)
              //   this.hls.attachMedia(video)
              //   this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
              //     video.play()
              //   })
              // }
            } else {
            // eslint-disable-next-line global-require
              video.poster = require('@/assets/images/icons/no-signal.gif')
            }
          })
        // eslint-disable-next-line no-unused-vars
          .catch(error => {
            // console.log(error, i)
            const video = document.getElementById(`video${i}`)
            // eslint-disable-next-line global-require
            video.poster = require('@/assets/images/icons/no-signal1.gif')
          })
      } else {
        const video = document.querySelector(`#video${i}`)
        // eslint-disable-next-line global-require
        video.poster = require('@/assets/images/icons/no-signal1.gif')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
